import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class Facebook extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: colors('Lapel'),
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 115 220"
        width={width}
      >
        <path
          d="M277.409,297.307 L277.409,197.504 L310.908,197.504 L315.924,158.609 L277.409,158.609 L277.409,133.777 C277.409,122.516 280.536,114.842 296.684,114.842 L317.28,114.833 L317.28,80.045 C313.718,79.571 301.492,78.512 287.268,78.512 C257.573,78.512 237.243,96.638 237.243,129.925 L237.243,158.609 L203.658,158.609 L203.658,197.504 L237.243,197.504 L237.243,297.307 L277.409,297.307 Z"
          transform="translate(-203 -78)"
          fillRule="nonzero"
          fill={strokeColor}
        />
      </SVGElement>
    );
  }
}
